import { PasswordParams } from '../types/PasswordParams';
import { useMutation, useQueryClient } from "@tanstack/react-query";
import axios, { AxiosError, AxiosResponse } from "axios";
import Problem from "../types/Problem";

export const useTestPassword = () => {
    const queryClient = useQueryClient();
    
    const url = 'accountmanagement/TestPassword';

    return useMutation<AxiosResponse, AxiosError<Problem>, PasswordParams>({
        mutationFn: (p) => axios.post(url, p, { headers: { "Content-Type": "application/json" } }),
    });
};

export const useChangePassword = () => {
    const queryClient = useQueryClient();

    const url = 'accountmanagement/changepassword';

    return useMutation<AxiosResponse, AxiosError<Problem>, PasswordParams>({
        mutationFn: (p) => axios.post(url, p, { headers: { "Content-Type": "application/json" } }),
    });
};
